import { useMemo } from 'react';
import { useCategoryStore } from '../stores/categoryStore';

export function useCategories() {
  const { categories } = useCategoryStore();

  const categoryMap = useMemo(() => {
    return categories.reduce((acc, category) => {
      acc[category.id] = category;
      return acc;
    }, {} as Record<string, typeof categories[0]>);
  }, [categories]);

  const getCategoryColor = (categoryId: string | undefined) => {
    return categoryMap[categoryId ?? '']?.color || '#e2e8f0'; // Default to light gray
  };

  const getCategoryName = (categoryId: string | undefined) => {
    return categoryMap[categoryId ?? '']?.name || '';
  };

  const getCategoryIcon = (categoryId: string | undefined) => {
    return categoryMap[categoryId ?? '']?.icon || '📌';
  };

  return {
    categories,
    getCategoryColor,
    getCategoryName,
    getCategoryIcon,
  };
}